import { render, staticRenderFns } from "./UpdatePerformanceReportSectionPage.vue?vue&type=template&id=7782413e&scoped=true"
import script from "./UpdatePerformanceReportSectionPage.vue?vue&type=script&lang=js"
export * from "./UpdatePerformanceReportSectionPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7782413e",
  null
  
)

export default component.exports